'use strict';

var _ = require('lodash');

/** @InviteToSiteStore */
var InviteToSiteStore = function InviteToSiteStore ($http, $timeout, APP_DISPATCHER_ID, Flux, IdentityService, InviteToSiteActions, TopControlsActions, Utils) {

  var ShareStore = Flux.Store.get('SiteStore'),

  //Store init
  InviteToSiteStore = Flux.Store.create({
    name: 'InviteToSiteStore',
    events: {
      Changed : true
    }
  });

  // Null initial state
  InviteToSiteStore.$state = {
    cancelPromise: null,
    dialogVisibility : false
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  InviteToSiteStore.init = function init () {
    var dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);
    dispatcher.register(InviteToSiteActions.InviteToSite, this._handleInviteToSite.bind(this));
    dispatcher.register(InviteToSiteActions.CancelInviteToSite, this._handleCancelInviteToSite.bind(this));

  }.bind(this);


  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handles the visiblilty flag to show/hide the modal
   * Broken into two methods because when clearing the notification, the controller was reading this value and opening the modal again
   */
  this._handleInviteToSite = function _handleInviteToSite () {
    InviteToSiteStore.$set('dialogVisibility', true);
    InviteToSiteStore.emit(InviteToSiteStore.Events.Changed);

  };

  this._handleCancelInviteToSite = function _handleCancelInviteToSite () {
    InviteToSiteStore.$set('dialogVisibility', false);
    InviteToSiteStore.emit(InviteToSiteStore.Events.Changed);
  };


  this._handleInviteToSiteStoreChange = function _handleInviteToSiteStoreChange() {
    angular.extend(InviteToSiteStore.$state, {
      dialogVisibility : InviteToSiteStore.get('dialogVisibility')
    });
  };

  InviteToSiteStore.on(InviteToSiteStore.Events.Changed, this._handleInviteToSiteStoreChange.bind(this));

  return InviteToSiteStore;
};

InviteToSiteStore.$inject = ['$http', '$timeout', 'APP_DISPATCHER_ID', 'sbFlux', 'IdentityService', 'InviteToSiteActions', 'TopControlsActions', 'Utils'];
module.exports = InviteToSiteStore;


// WEBPACK FOOTER //
// ./src/app/dash/invite/InviteToSiteStore.js